import { profile } from './profile';

const esCR = {
  ...profile,
};

export default esCR;
